module.exports = __webpack_public_path__ + "178827aac62c7e15e1f2dd1dd213d727.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/mustache-chef.png
// module id = 1206
// module chunks = 0